// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-widget {
  position: relative;
}
.location-widget .menu-button {
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.location-widget .menu-button ion-icon {
  font-size: 18px;
  color: #666;
}
.location-widget .location-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
  flex: 1;
  min-height: 0;
}
.location-widget .location-container .map-container {
  flex: 1;
  min-height: 0;
  border-radius: 8px;
}
.location-widget .location-container .map-container iframe {
  border-radius: 8px;
  width: 100%;
  height: calc(100% - 25px);
}
.location-widget .no-location-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 5px;
}
.location-widget .no-location-container .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.location-widget .no-location-container .loading-container ion-spinner {
  --color: #ed143d;
  width: 24px;
  height: 24px;
}
.location-widget .no-location-container .loading-container span {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  line-height: 1.4;
}
.location-widget .no-location-container .permission-denied,
.location-widget .no-location-container .request-permission {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.location-widget .no-location-container .permission-denied ion-icon,
.location-widget .no-location-container .request-permission ion-icon {
  font-size: 32px;
  color: #ed143d;
}
.location-widget .no-location-container .permission-denied span,
.location-widget .no-location-container .request-permission span {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  line-height: 1.4;
}
.location-widget .no-location-container .permission-denied ion-button,
.location-widget .no-location-container .request-permission ion-button {
  --color: #ed143d;
  --background: transparent;
  font-size: 12px;
  height: 32px;
  margin-top: 8px;
}

.location-menu-popover {
  --width: 200px;
}
.location-menu-popover ion-list {
  padding: 0;
  font-weight: 600;
}
.location-menu-popover div {
  display: flex;
  align-items: center;
  padding: 10px 5px;
  gap: 5px;
  cursor: pointer;
}
.location-menu-popover div ion-icon {
  font-size: 18px;
  color: #666;
}
.location-menu-popover div ion-label {
  font-size: 14px;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/location-widget/location-widget.component.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;AAFF;AAGE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADJ;AAEI;EACE,eAAA;EACA,WAAA;AAAN;AAGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;AADJ;AAGI;EACE,OAAA;EACA,aAAA;EACA,kBAAA;AADN;AAGM;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;AADR;AAME;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAJJ;AAMI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAJN;AAMM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AAJR;AAOM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AALR;AASI;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAPN;AASM;;EACE,eAAA;EACA,cAAA;AANR;AASM;;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AANR;AASM;;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AANR;;AAYA;EACE,cAAA;AATF;AAWE;EACE,UAAA;EACA,gBAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,eAAA;AAVJ;AAWI;EACE,eAAA;EACA,WAAA;AATN;AAYI;EACE,eAAA;EACA,WAAA;AAVN","sourcesContent":["  \n\n.location-widget {\n\n  position: relative;\n  .menu-button {\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    ion-icon {\n      font-size: 18px;\n      color: #666;\n    }\n  }\n  .location-container {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    position: relative;\n    flex: 1;\n    min-height: 0;\n\n    .map-container {\n      flex: 1;\n      min-height: 0;\n      border-radius: 8px;\n\n      iframe {\n        border-radius: 8px;\n        width: 100%;\n        height: calc(100% - 25px);\n      }\n    }\n  }\n\n  .no-location-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    text-align: center;\n    padding: 5px;\n\n    .loading-container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 12px;\n\n      ion-spinner {\n        --color: #ed143d;\n        width: 24px;\n        height: 24px;\n      }\n\n      span {\n        font-size: 12px;\n        color: #666;\n        font-weight: 500;\n        line-height: 1.4;\n      }\n    }\n\n    .permission-denied,\n    .request-permission {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 12px;\n\n      ion-icon {\n        font-size: 32px;\n        color: #ed143d;\n      }\n\n      span {\n        font-size: 12px;\n        color: #666;\n        font-weight: 500;\n        line-height: 1.4;\n      }\n\n      ion-button {\n        --color: #ed143d;\n        --background: transparent;\n        font-size: 12px;\n        height: 32px;\n        margin-top: 8px;\n      }\n    }\n  }\n}\n\n.location-menu-popover {\n  --width: 200px;\n\n  ion-list {\n    padding: 0;\n    font-weight: 600;\n  }\n\n  div {\n    display: flex;\n    align-items: center;\n    padding: 10px 5px;\n    gap: 5px;\n    cursor: pointer;\n    ion-icon {\n      font-size: 18px;\n      color: #666;\n    }\n\n    ion-label {\n      font-size: 14px;\n      color: #333;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
